


























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ElementResultsTooltip extends Vue {
  @Prop({ default: '', required: true }) type!: string;
  @Prop({ default: null, required: false }) secondtype!: string | null;
  @Prop({ default: null, required: false }) normsType!: any | null;

  breakLine(val: string) {
    return val.replace(/(\r\n|\n)/g, '<br/><br/>');
  }
}
